/**
 * @file queries.js is a file for all SiteSettings queries
 *
 * @author Steven Secreti
 */
import { gql } from "@apollo/client";

/**
 * @constant GET_SITE_SETTINGS
 *
 * @summary GraphQL query that returns the singleton site settings document.
 */
export const GET_SITE_SETTINGS = gql`
	query getSiteSettings {
		getSiteSettings {
			installLeadTime {
				enabled
				message
			}
		}
	}
`;
